<template>
  <div>
    <v-container fluid grid-list-md  v-if="showGoodByeImage">
      <v-layout row wrap>
        <v-flex xs12>
          <div class="goodbye-title">You are now being redirected to our partner’s page.</div>
        </v-flex>
        <v-flex xs12>
          <v-img
            alt=''
            :src='images["GoodBye"]'
            height='600px'
            contain />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import GoodBye from '@/assets/offers/GoodBye.png';

export default {
  name: 'UsedCardboardBoxes',
  data() {
    return {
      images: {
        GoodBye,
      },
      showGoodByeImage: true,
    };
  },
  computed: {
  },
  props: {
  },
  mounted() {
    setTimeout(() => {
      this.showGoodByeImage = false;
      window.location.href = 'https://shareasale.com/r.cfm?b=1765657&u=2915318&m=22817&urllink=&afftrack="';
    }, 2000);
  },
};
</script>

<style lang='scss' scoped>
.goodbye-title {
  font-size: 24px;
}
</style>
